import { render, staticRenderFns } from "./LandRegister.vue?vue&type=template&id=3ba334b9&scoped=true"
import script from "./LandRegister.vue?vue&type=script&lang=js"
export * from "./LandRegister.vue?vue&type=script&lang=js"
import style0 from "./LandRegister.vue?vue&type=style&index=0&id=3ba334b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba334b9",
  null
  
)

export default component.exports